let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jUUh4")).then(() => parcelRequire('g52eJ'));